import { render, staticRenderFns } from "./GridAggregateCell.vue?vue&type=template&id=632bdf78&scoped=true"
import script from "./GridAggregateCell.vue?vue&type=script&lang=ts"
export * from "./GridAggregateCell.vue?vue&type=script&lang=ts"
import style0 from "./GridAggregateCell.vue?vue&type=style&index=0&id=632bdf78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "632bdf78",
  null
  
)

export default component.exports